module.exports = __webpack_public_path__ + "static/media/bg5.9fbfe3f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg5.jpg
// module id = 805
// module chunks = 0